/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { ObservableMap } from '@typescript-kit/core';
import { ViewService } from '@angular-kit/view';

import { TimeRecordingViewModel } from '../view-model/time-recording.view-model';
import { EmployeeTimeRecordingMenuViewService } from './employee-time-recording-menu.view-service';
import { EmployeeTimeRecordingTableViewService } from './employee-time-recording-table.view-service';
import { EmployeeTimeRecordingSummaryViewService } from './employee-time-recording-summary.view-service';
import { EmployeeTimeRecordingDetailComponentModel } from '../component-model/employee-time-recording-detail.component-model';
import { EmployeeTimeRecordingSharedViewService } from './employee-time-recording-shared.view-service';

@Injectable()
export class EmployeeTimeRecordingDetailViewService extends ViewService<TimeRecordingViewModel, EmployeeTimeRecordingDetailComponentModel> {
  private readonly sharedViewService = this.injector.get(EmployeeTimeRecordingSharedViewService);
  private readonly menuViewService = new EmployeeTimeRecordingMenuViewService(this.injector);
  private readonly tableViewService = new EmployeeTimeRecordingTableViewService(this.injector);
  private readonly summaryViewService = new EmployeeTimeRecordingSummaryViewService(this.injector);

  initialize(): void {
    const viewModel = this.sharedViewService.viewModel;
    this.menuViewService.initialize(viewModel);
    this.tableViewService.initialize(viewModel);
    if (viewModel.printView) {
      this.summaryViewService.initialize(viewModel);
    }
    super.initialize(viewModel);
  }

  finalize(): void {
    this.menuViewService.finalize();
    this.tableViewService.finalize();
    if (this.summaryViewService.isInitialized) {
      this.summaryViewService.finalize();
    }
    super.finalize();
  }

  protected createComponentModel(): EmployeeTimeRecordingDetailComponentModel {
    return new EmployeeTimeRecordingDetailComponentModel({
      items: new ObservableMap({
        menu: this.menuViewService.componentModel,
        table: this.tableViewService.componentModel,
        summary: this.summaryViewService.componentModel
      })
    });
  }

}
